import { Component } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { LocalStorageService } from 'src/app/_services/localStorage.service';

@Component({
  selector: 'app-legals-modal',
  templateUrl: './legals-modal.component.html',
  styleUrls: ['./legals-modal.component.scss'],
  standalone: false
})
export class LegalsModalComponent {
  role: any;

  constructor(
    private modalController: ModalController,
    private localStorageService: LocalStorageService
  ) {
    this.role = this.localStorageService.getUserRole();
  }

  closeModal() {
    this.modalController.dismiss();
  }
}

